import { clientTransformed } from '@common/utils/rest';

const URL_PREFIX = 'api/invites';

const getUrl = (path) => {
  return `${URL_PREFIX}/${path}`;
};

export const getInvites = async ({ filtering, pagination }) => {
	return clientTransformed({
    path: getUrl('smartlist'),
    method: 'POST',
		entity: {
			...filtering,
			...pagination,
		},
  }).then(
    (response) => {
      return response.entity;
    },
  );
};